import * as Sentry from '@sentry/browser';
import { useCookies } from 'react-cookie';

export type PublishNotificationMailType = 'template_published' | 'profile_completed' | 'not_request_link' | 'general';

type Props = {
  companyId: string;
};

export const usePublishNotification = ({ companyId }: Props) => {
  const [cookies] = useCookies(['expiry', 'access-token', 'client', 'uid', 'user-type']);

  const sendNotifyPublishEmail = async (mailType: PublishNotificationMailType) => {
    const url = `${process.env.NEXT_PUBLIC_DEV_BACKEND_URL}/admin/companies/${companyId}/send_publish_notification_email`;

    const result = await fetch(url, {
      method: 'POST',
      mode: 'cors',
      headers: {
        uid: cookies.uid,
        client: cookies.client,
        'access-token': cookies['access-token'],
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        mail_type: mailType,
      }),
    })
      .then((response) => {
        return response.json();
      })
      .catch((error) => {
        Sentry.captureException(error);
        console.error('通信に失敗しました', error);
      });

    return result;
  };

  return {
    sendNotifyPublishEmail,
  };
};
